/// <reference lib="dom" />

import { ModalsProvider } from '@snowit/hooks/useModals';
import { Notifications } from '@snowit/hooks/useNotifications';
import { Provider as StyleProvider } from '@snowit/system/useStyle';
import { Router } from '@snowit/wouter';

import { createRoot } from 'react-dom/client';
import '@snowit/style';

import type { FC } from 'react';

import AuthProvider from '@snowit/system/useAuth/AuthProvider';
import Motion from '@snowit/ui/utils/Motion';
import combineProviders from '@snowit/utils/combineProviders';

import App from './App';
import BadgeProvider from './components/Badges/BadgeProvider';

// providers are composed top to bottom
const MasterProvider = combineProviders([
  // must stay outermost: every `m.*` component below needs its feature context
  [Motion],
  [StyleProvider],
  [AuthProvider],
  // [BrowserRouter],
  [Router],
  [ModalsProvider],
  [BadgeProvider],
]);

const rootElement = document.getElementById('root');

const render = (Component: FC) => {
  const root = createRoot(rootElement!);
  const Container = () => (
    <MasterProvider>
      <Component />
      <Notifications />
    </MasterProvider>
  );
  root.render(<Container />);
};

render(App);
